define('app/views/yadisa_comment_section_view',['app/setup'], function (takhfifan) {
  takhfifan.YadisaCommentSectionView = Backbone.View.extend({

    events: {
      'click .yadisa-comments-next-btn' : 'goNext',
      'click .yadisa-comments-prev-btn' : 'goPrev'
    },

    initialize: function() {
      this.$el.find('li').first().addClass('current');
      this.startRotation();
      this.counter = 0;

      var _this = this;
      this.$el.mouseover(function() {
        clearInterval(_this.interval);
      });

      this.$el.mouseleave(function() {
        _this.startRotation();
      });
    },

    startRotation: function() {
      var _this = this;
      this.interval = setInterval(function() {
        _this.goNext();
      }, 7500);
    },

    goNext: function() {
      var items = this.$el.find('li');
      items[this.counter].classList.remove('current');
      this.counter = (this.counter + 1) % items.length;
      items[this.counter].classList.add('current');
    },

    goPrev: function() {
      var items = this.$el.find('li');
      items[this.counter].classList.remove('current');
      this.counter = (this.counter + items.length - 1) % items.length;
      items[this.counter].classList.add('current');
    }
  });
});

